import { useQuery } from "@tanstack/react-query";
import { useApi } from "@/core/api";

interface JobInvoice {
  id: number | null;
  number: string | null;
  job_number: string | null;
}

export const useJobInvoice = (
  businessId: string | null,
  jobId: number,
  enabled: boolean,
) => {
  const api = useApi();

  return useQuery({
    queryKey: ["apJobInvoice", businessId, jobId],
    queryFn: async () => {
      const { data } = await api.get<JobInvoice>(
        `/businesses/${businessId}/ap/jobs/${jobId}/invoice`,
      );
      return data;
    },
    enabled: enabled && !!businessId,
    staleTime: (query) => (query.state.data?.id == null ? 0 : 5 * 60 * 1000),
    retry: false,
    refetchOnWindowFocus: false,
  });
};
